if (!customElements.get('best-sellers-picks')) {
  customElements.define(
    'best-sellers-picks',
    class BestSellersPicks extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.pagination = this.querySelector('[data-pagination]');
        this.items = Array.from(this.querySelectorAll('.best-sellers-picks__item'));
        if (!this.viewport) return;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.scrollToPrev = this.scrollToPrev.bind(this);
        this.scrollToNext = this.scrollToNext.bind(this);
        this.onPaginationClick = this.onPaginationClick.bind(this);

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        if (this.prevButton) this.prevButton.addEventListener('click', this.scrollToPrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.scrollToNext);
        if (this.pagination) this.pagination.addEventListener('click', this.onPaginationClick);

        this.renderPagination();
        this.updateControls();
      }

      disconnectedCallback() {
        if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.prevButton) this.prevButton.removeEventListener('click', this.scrollToPrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.scrollToNext);
        if (this.pagination) this.pagination.removeEventListener('click', this.onPaginationClick);
      }

      scrollToPrev() {
        this.scrollByAmount(-1);
      }

      scrollToNext() {
        this.scrollByAmount(1);
      }

      scrollByAmount(direction) {
        const distance = this.getSlideStep();
        this.viewport.scrollBy({
          left: distance * direction,
          behavior: 'smooth',
        });
      }

      onResize() {
        this.renderPagination();
        this.updateControls();
      }

      onScroll() {
        this.updateControls();
      }

      onPaginationClick(event) {
        const dot = event.target.closest('[data-index]');
        if (!dot) return;
        const index = Number(dot.dataset.index);
        if (Number.isNaN(index)) return;
        this.scrollToIndex(index);
      }

      getSlideStep() {
        if (this.items.length > 1) {
          const itemStep = this.items[1].offsetLeft - this.items[0].offsetLeft;
          if (itemStep > 0) return itemStep;
        }
        return Math.max(this.viewport.clientWidth * 0.9, 260);
      }

      getCurrentIndex() {
        if (!this.items.length) return 0;
        const current = this.viewport.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Math.abs(this.items[0].offsetLeft - current);

        this.items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - current);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      scrollToIndex(index) {
        if (!this.items[index]) return;
        this.viewport.scrollTo({
          left: this.items[index].offsetLeft,
          behavior: 'smooth',
        });
      }

      renderPagination() {
        if (!this.pagination) return;
        if (this.items.length <= 1) {
          this.pagination.hidden = true;
          this.pagination.innerHTML = '';
          return;
        }

        if (this.pagination.children.length !== this.items.length) {
          this.pagination.innerHTML = this.items
            .map((_, index) => {
              const itemNumber = index + 1;
              return `<button class="best-sellers-picks__dot" type="button" data-index="${index}" aria-label="Go to product ${itemNumber}"></button>`;
            })
            .join('');
        }

        this.pagination.hidden = false;
        this.updatePaginationState();
      }

      updatePaginationState() {
        if (!this.pagination || this.pagination.hidden) return;
        const currentIndex = this.getCurrentIndex();
        const dots = this.pagination.querySelectorAll('[data-index]');
        dots.forEach((dot, index) => {
          const isActive = index === currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      updateControls() {
        const maxScrollLeft = this.viewport.scrollWidth - this.viewport.clientWidth;
        const current = this.viewport.scrollLeft;
        const threshold = 2;

        if (this.prevButton) this.prevButton.disabled = current <= threshold;
        if (this.nextButton) this.nextButton.disabled = current >= maxScrollLeft - threshold;

        this.updatePaginationState();
      }
    }
  );
}
